module.exports = __webpack_public_path__ + "img/javaMobile1.a5c5c866.jpg";